import { FC } from 'react'
import { Discount } from 'components/Discounts'
import { UserProtectedRoute } from 'routes'

const DiscountPage: FC = () => (
  <UserProtectedRoute>
    <Discount />
  </UserProtectedRoute>
)

export default DiscountPage
